let ibaseURL;
try {
  if (process.env.REACT_APP_HOST) {
    ibaseURL =
      process.env.REACT_APP_HOST +
      (process.env.REACT_APP_PORT ? ":" + process.env.REACT_APP_PORT : "");
  }
} catch (error) {
  console.log("error", error);
}
export default {
  SmartParkService: {
    //baseURL: "http://varidx-test-webapp.eastus.cloudapp.azure.com:5000",
    // baseURL: ibaseURL || 'http://localhost:5000',
    baseURL: ibaseURL || "https://dev.varidx.io",
    //baseURL: "http://devabhi1j7afurnw37lcy.eastus.cloudapp.azure.com:5000",
    //baseURL: ibaseURL || 'http://localhost:5000',
    //baseURL: "https://morrisville.varidx.io",
  },
};

export const Microsoft_AD_Config = {
  clientId: "65125d76-9c04-424e-8996-d6eeb6c2b4c9",
  redirectUri: [
    "http://localhost/",
    "https://morrisville.varidx.io/",
    "https://smartmorrisville.townofmorrisville.org/",
    "https://smartcity.townofmorrisville.org/",
  ],
  scopes: ["user.read"],
};

export const RuleEngineNotificationTemplate = {
  email: ` <br/>&nbsp;Dear User,<br/>
  As per the [RULE_NAME] rule configured in Cedar Fork District Park.<br/>
  Rule Criteria:<br/>
  [SENSORS_RULE_CRITERIA]<br/>
  Actions: [FIELD]-[ACTIONS]&nbsp;<br/>`,
  sms: `Hi,	
	As per the [RULE_NAME] rule configured in the [PARK_NAME] application,
  
	Rule Criteria: [SENSORS_RULE_CRITERIA]
  
	Actions: [FIELD]-[ACTIONS]`,
};
export const moistureChart = { useDummyData: false };

export const GATracingCode = "UA-202491828-1";
export const tokenCheckInterval = 10 * 60 * 1000;
export const paperAutoAdjustIntervalInMS = 500;
export const States = [
  { StateCode: "AL", StateName: "ALABAMA" },
  { StateCode: "AK", StateName: "ALASKA" },
  { StateCode: "AZ", StateName: "ARIZONA" },
  { StateCode: "AR", StateName: "ARKANSAS" },
  { StateCode: "CA", StateName: "CALIFORNIA" },
  { StateCode: "CO", StateName: "COLORADO" },
  { StateCode: "CT", StateName: "CONNECTICUT" },
  { StateCode: "DE", StateName: "DELAWARE" },
  { StateCode: "DC", StateName: "DISTRICT OF COLUMBIA" },
  { StateCode: "FL", StateName: "FLORIDA" },
  { StateCode: "GA", StateName: "GEORGIA" },
  { StateCode: "HI", StateName: "HAWAII" },
  { StateCode: "ID", StateName: "IDAHO" },
  { StateCode: "IL", StateName: "ILLINOIS" },
  { StateCode: "IN", StateName: "INDIANA" },
  { StateCode: "IA", StateName: "IOWA" },
  { StateCode: "KS", StateName: "KANSAS" },
  { StateCode: "KY", StateName: "KENTUCKY" },
  { StateCode: "LA", StateName: "LOUISIANA" },
  { StateCode: "ME", StateName: "MAINE" },
  { StateCode: "MD", StateName: "MARYLAND" },
  { StateCode: "MA", StateName: "MASSACHUSETTS" },
  { StateCode: "MI", StateName: "MICHIGAN" },
  { StateCode: "MN", StateName: "MINNESOTA" },
  { StateCode: "MS", StateName: "MISSISSIPPI" },
  { StateCode: "MO", StateName: "MISSOURI" },
  { StateCode: "MT", StateName: "MONTANA" },
  { StateCode: "NE", StateName: "NEBRASKA" },
  { StateCode: "NV", StateName: "NEVADA" },
  { StateCode: "NH", StateName: "NEW HAMPSHIRE" },
  { StateCode: "NJ", StateName: "NEW JERSEY" },
  { StateCode: "NM", StateName: "NEW MEXICO" },
  { StateCode: "NY", StateName: "NEW YORK" },
  { StateCode: "NC", StateName: "NORTH CAROLINA" },
  { StateCode: "ND", StateName: "NORTH DAKOTA" },
  { StateCode: "OH", StateName: "OHIO" },
  { StateCode: "OK", StateName: "OKLAHOMA" },
  { StateCode: "OR", StateName: "OREGON" },
  { StateCode: "PA", StateName: "PENNSYLVANIA" },
  { StateCode: "RI", StateName: "RHODE ISLAND" },
  { StateCode: "SC", StateName: "SOUTH CAROLINA" },
  { StateCode: "SD", StateName: "SOUTH DAKOTA" },
  { StateCode: "TN", StateName: "TENNESSEE" },
  { StateCode: "TX", StateName: "TEXAS" },
  { StateCode: "UT", StateName: "UTAH" },
  { StateCode: "VT", StateName: "VERMONT" },
  { StateCode: "VA", StateName: "VIRGINIA" },
  { StateCode: "WA", StateName: "WASHINGTON" },
  { StateCode: "WV", StateName: "WEST VIRGINIA" },
  { StateCode: "WI", StateName: "WISCONSIN" },
  { StateCode: "WY", StateName: "WYOMING" },
  { StateCode: "PR", StateName: "PUERTO RICO" },
  { StateCode: "GU", StateName: "GUAM" },
  { StateCode: "AS", StateName: "AMERICAN SAMOA" },
];

export const Countries = [
  "United States",
  "Canada",
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and/or Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Cook Islands",
  "Costa Rica",
  "Croatia (Hrvatska)",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "France, Metropolitan",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard and Mc Donald Islands",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran (Islamic Republic of)",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Democratic People's Republic of",
  "Korea, Republic of",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libyan Arab Jamahiriya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States of",
  "Moldova, Republic of",
  "Monaco",
  "Mongolia",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia South Sandwich Islands",
  "Spain",
  "Sri Lanka",
  "St. Helena",
  "St. Pierre and Miquelon",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen Islands",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States minor outlying islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City State",
  "Venezuela",
  "Vietnam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna Islands",
  "Western Sahara",
  "Yemen",
  "Yugoslavia",
  "Zaire",
  "Zambia",
  "Zimbabwe",
];
